import { Box, Button, Typography } from '@mui/material'
import React, { ReactNode } from 'react'

export interface ITopbarContentProps {
  action?: ReactNode
  title?: string
}

export const TopbarContent = (props: ITopbarContentProps): JSX.Element => {
  const { action, title } = props

  return (
    <>
      <Box display='flex' justifyContent='center' width='100%'>
        <Box sx={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
          <Typography variant='h4'>{title}</Typography>
        </Box>
        {action}
      </Box>
    </>
  )
}
